import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import EmergencyBanner from '../components/EmergencyBanner';
import TransformationShowcase from '../components/TransformationShowcase';
import BeforeAfterComparison from '../components/BeforeAfterComparison';
import PortfolioSection from '../components/PortfolioSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <EmergencyBanner />
      <ServicesSection />
      <TransformationShowcase />
      <BeforeAfterComparison />
      <PortfolioSection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Home;
